const cardsData = [
      {
      name: "MA",
      textfront: "Moving Average",
      textback: "Smooths out price data by creating a constantly updated average price",
      bgcolor: 224477,
      },
      {
      name: "EMA",
      textfront: "Exponential Moving Average",
      textback: "Smooths out price data by creating a constantly updated average price",
      bgcolor: 334477,
      },
      {
        name: "MACD",
        textfront: "Moving Average Divergence Convergence",
        textback: "Smooths out price data by creating a constantly updated average price",
        bgcolor: 226677,
      },
      {
      name: "BOLL",
      textfront: "Bollinger Bands",
      textback: "Smooths out price data by creating a constantly updated average price",
      bgcolor: 224477,
      },
      {
        name: "RSI",
        textfront: "Relative Strength Index",
        textback: "Smooths out price data by creating a constantly updated average price",
        bgcolor: 443377,
      },
      {
      name: "KDJ",
      textfront: "Random Index",
      textback: "Smooths out price data by creating a constantly updated average price",
      bgcolor: 223355,
      },
      {
        name: "OBV",
        textfront: "On-Balance Volume ",
        textback: "Smooths out price data by creating a constantly updated average price",
        bgcolor: 555577,
      },
      {
      name: "VOL",
      textfront: "Volume",
      textback: "Smooths out price data by creating a constantly updated average price",
      bgcolor: 335566,
      },

  ]


export default cardsData;
